import { render, staticRenderFns } from "./DialogHeader.vue?vue&type=template&id=297fd4a1&"
import script from "./DialogHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports